export default [
  {
    path: "/dashboard",
    name: "dashboard",
    meta: {
      title: "首页", //meta里面也要有title 用于面包屑上使用
      affix: true,
      showFooter: true,
      icon: "home"
    },
    component: () => import(/* webpackChunkName: "constantModule" */"@/views/dashboard")
  },
  {
    path: "/redirect/:path(.*)",
    name: "redirect",
    meta: {},
    hidden: true,
    component: () => import(/* webpackChunkName: "constantModule" */"@/views/constant/redirect")
  },
  {
    path: "/404",
    name: "page404",
    component: () => import("@/views/error-module/404"),
    meta: {
      title: "404"
    },
    hidden: true
  },
  {
    path: "/401",
    name: "page401",
    component: () => import("@/views/error-module/401"),
    meta: {
      title: "401"
    },
    hidden: true
  },
  {
    path: "/not-found",
    name: "notFound",
    component: () => import("@/views/error-module/index"),
    meta: {
      title: "notFound"
    },
    hidden: true
  }

]